// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__w9dN7"};